import React from 'react';
import {CommonEdit} from '../Common';
import {getInputs} from './Common';

export const ContractIndexValueEdit = props => (
  <CommonEdit {...props} fields={getInputs()} />
);
